/*
 * All credits to Netflix for providing this approach to ES6 feature detection.
 * Indirect eval fix applied to satisfy bundlers (Rolldown/Rollup/ESBuild).
 * License: MIT
 */

// Create a reference to indirect eval
const indirectEval = eval;

try {
  // Use indirectEval() instead of eval() to run in global scope
  indirectEval(
    'class ಠ_ಠ extends Array{constructor(j=`a`,...c){const q=(({u: e})=>{return {[`${c}`]:Symbol(j)};})({});super(j,q,...c)}}new Promise(f=>{const a=function*(){return "\\\\u{20BB7}".match(/./u)[0].length===2||!0};for (let z of a()){const [x,y,w,k]=[new Set(),new WeakSet(),new Map(), new WeakMap()];break}f(new Proxy({},{get:(h,i) =>i in h ?h[i]:"j".repeat(0o2)}))}).then(t => new ಠ_ಠ(t.d))',
  )
}
catch (e) {
  window.location.href = '/browser-support.html'
}

// test for localstorage
try {
  // Indirectly check for localStorage existence
  if (!window.localStorage) {
    throw new Error('localStorage not supported');
  }
}
catch (error) {
  window.location.href = '/storage-support.html'
}
